<div class="tabs">
    <ul class="nav nav-tabs">
        @for (tab of tabList; track tab) {
            <li (click)="changeTab(tab.title)" class="nav-item">
                <a class="nav-link" [class.active]="tab.isActive">{{ tab.title }}</a>
            </li>
        }
    </ul>
    <div class="tab-container" [style.maxHeight]="height">
        <ng-content></ng-content>
    </div>
</div>
